<template>
  <v-dialog v-model="dialogIsOpen" max-width="450px">
    <template #activator="{ on, attrs }">
      <v-btn outlined color="secondary lighten-2" width="14rem" class="mt-5 rounded-pill text-capitalize" v-on="on" v-bind="attrs">
        {{ $t('button.cancelAppointment') }}
      </v-btn>
    </template>
    <v-card class="d-flex flex-column pt-16 px-16 rounded-lg" min-height="50vh">
      <v-card-text class="my-auto d-flex flex-column align-center">
        <p class="text-center font-weight-medium text-subtitle-1 px-4">
          {{ $t('message.cancelAppointmentPrompt') }}
        </p>
      </v-card-text>

      <v-card-actions class="d-flex flex-column align-stretch">
        <app-button invert gradient :label="$t('button.cancelAppointmentAgree')" @click="cancelAppointment" class="py-5" />
        <v-btn outlined color="secondary lighten-2" class="ml-0 mt-5 rounded-pill text-transform-none mb-12" @click="dialogIsOpen = false">{{ $t('button.cancelAppointmentDismiss') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: ['bookingId'],

  data: () => ({
    dialogIsOpen: false
  }),

  methods: {
    ...mapActions('appointment', {
      cancelAppointmentAction: 'cancelAppointment'
    }),
    async cancelAppointment() {
      const requestBody = {
        booking_id: this.bookingId
      }
      await this.cancelAppointmentAction(requestBody)
        .then((_) => {
          this.$emit('successfulCancel')
        })
        .catch((error) => {
          this.$emit('failCancel', { message: error.error_message })
        })
        .finally(() => {
          this.dialogIsOpen = false
        })
    }
  }
}
</script>
